import React from "react";
import PropTypes from "prop-types";
import ListContainer from "./ListContainer";
import { navigationPropType } from "@template/state/modules/navigation";
import CarouselContainer from "./CarouselContainer";
import styles from "./index.css";

const sideNavigationContainers = {
  list: ListContainer,
  carousel: CarouselContainer
};

const renderTitle = (label, styleType) =>
  label && styleType !== "noTitle" ? (
    <h3 className={styles.title}>{label}</h3>
  ) : null;

const SideNavigationContainer = ({
  setNavActiveItem,
  saveNavigationItem,
  item,
  sideNavLevel,
  addLastFocusElement,
  marketplaceVintageLinkMobile = {},
  testIsLoaded
}) => {
  const isValidLayout = Object.prototype.hasOwnProperty.call(
    sideNavigationContainers,
    item.smallAndMediumLayout
  );

  const isClothingCategory = () =>
    item.labelPath[2] === "Categories" &&
    item.labelPath[3] === "Clothing" &&
    item.labelPath[4].toLowerCase() === "shop by product" &&
    item.labelPath.length === 5;

  if (
    isClothingCategory() &&
    marketplaceVintageLinkMobile.enabled &&
    item.items.length &&
    testIsLoaded
  ) {
    const fullTextGender = item.gender === "WW" ? "women" : "men";
    item.items.push({
      alias: null,
      id: `marketplaceLinkMobile`,
      items: [],
      excludes: [],
      label: "Vintage - Marketplace.ASOS.com",
      type: "link",
      link: `https://marketplace.asos.com/${fullTextGender}/just-in?tab=boutique&f:condition=12109&ctaref=mktp|${fullTextGender}|nav|justin|vintage&nlid=emf137_v2_${item.gender.toLowerCase()}newvariant`,
      linkType: "external",
      webLargePriority: 0,
      largeScreenStyleType: "premium",
      smallAndMediumStyleType: "premium",
      smallAndMediumImageUrl: `https://content.asos-media.com/-/media/Images/Target/2020/MVT/navigation_vintage_${
        item.gender === "MW" ? "man" : "woman"
      }.jpg`
    });
  }

  const Container = isValidLayout
    ? sideNavigationContainers[item.smallAndMediumLayout]
    : ListContainer;

  if (!item.items || !item.items.length) {
    return null;
  }

  return (
    <li className={styles.listContainer}>
      {renderTitle(item.label, item.smallAndMediumStyleType)}
      <Container
        setNavActiveItem={setNavActiveItem}
        saveNavigationItem={saveNavigationItem}
        item={item}
        sideNavLevel={sideNavLevel}
        addLastFocusElement={addLastFocusElement}
      />
    </li>
  );
};

SideNavigationContainer.propTypes = {
  setNavActiveItem: PropTypes.func.isRequired,
  item: navigationPropType.isRequired,
  saveNavigationItem: PropTypes.func,
  addLastFocusElement: PropTypes.func,
  sideNavLevel: PropTypes.string,
  marketplaceVintageLinkMobile: PropTypes.oneOfType([
    PropTypes.shape({
      enabled: PropTypes.bool
    }),
    PropTypes.bool
  ]),
  testIsLoaded: PropTypes.bool
};

SideNavigationContainer.defaultProps = {
  saveNavigationItem: /* istanbul ignore next */ () => {}
};

export default SideNavigationContainer;
